<template>
  <div class="dialog-mask" v-if="visible" @click.self="close">
    <div class="login-dialog">
      <div class="dialog-header">
        <h3>🔐 用户登录</h3>
        <button class="close-btn" @click="close">×</button>
      </div>
      
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label>用户名</label>
          <input type="text" v-model="form.username" placeholder="请输入用户名" required />
        </div>
        
        <div class="form-group">
          <label>密码</label>
          <input type="password" v-model="form.password" placeholder="请输入密码" required />
        </div>
        
        <div class="form-group captcha-group">
          <div class="captcha-input">
            <label>验证码</label>
            <input type="text" v-model="form.captcha" maxlength="4" placeholder="请输入验证码" required />
          </div>
          <div class="captcha-image" @click="refreshCaptcha" title="点击刷新验证码">
            <canvas ref="captchaCanvas" width="100" height="40"></canvas>
          </div>
        </div>
        
        <button type="submit" class="btn-login" :disabled="loading">
          {{ loading ? '登录中...' : '登 录' }}
        </button>
      </form>
      
      <div class="dialog-footer">
        <span>还没有账号？</span>
        <a @click="goRegister">立即注册</a>
      </div>
    </div>
  </div>
</template>

<script>
import { loginApi } from '@/api/index'

export default {
  name: 'LoginDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        captcha: ''
      },
      captchaCode: '',
      loading: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm()
        this.$nextTick(() => {
          this.refreshCaptcha()
        })
      }
    }
  },
  methods: {
    resetForm() {
      this.form = { username: '', password: '', captcha: '' }
      this.captchaCode = ''
    },
    close() {
      this.$emit('update:visible', false)
    },
    goRegister() {
      this.close()
      this.$emit('switch-register')
    },
    refreshCaptcha() {
      const canvas = this.$refs.captchaCanvas
      if (!canvas) return
      const ctx = canvas.getContext('2d')

      ctx.clearRect(0, 0, 100, 40)
      ctx.fillStyle = '#f5f5f5'
      ctx.fillRect(0, 0, 100, 40)

      const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
      let code = ''

      ctx.font = 'bold 24px Arial'
      ctx.textBaseline = 'middle'

      for (let i = 0; i < 4; i++) {
        const char = characters.charAt(Math.floor(Math.random() * characters.length))
        code += char
        ctx.fillStyle = `rgb(${Math.floor(Math.random() * 150)}, ${Math.floor(Math.random() * 150)}, ${Math.floor(Math.random() * 150)})`
        ctx.save()
        ctx.translate(20 * i + 15, 20)
        ctx.rotate((Math.random() - 0.5) * 0.4)
        ctx.fillText(char, 0, 0)
        ctx.restore()
      }

      this.captchaCode = code.toUpperCase()

      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.moveTo(Math.random() * 100, Math.random() * 40)
        ctx.lineTo(Math.random() * 100, Math.random() * 40)
        ctx.stroke()
      }

      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`
        ctx.beginPath()
        ctx.arc(Math.random() * 100, Math.random() * 40, 1, 0, 2 * Math.PI)
        ctx.fill()
      }
    },
    async handleLogin() {
      if (this.loading) return

      if (!this.form.username || !this.form.password) {
        this.$toast.warning('请输入用户名和密码')
        return
      }

      if (!this.form.captcha || this.form.captcha.length !== 4) {
        this.$toast.warning('请输入4位验证码')
        return
      }

      if (this.form.captcha.toUpperCase() !== this.captchaCode) {
        this.$toast.error('验证码错误，请重新输入')
        this.refreshCaptcha()
        this.form.captcha = ''
        return
      }

      try {
        this.loading = true
        const response = await loginApi({
          username: this.form.username,
          password: this.form.password
        })

        if (response.code === 200) {
          const token = response.data.token
          localStorage.setItem('token', token)
          localStorage.setItem('userInfo', JSON.stringify(response.data))
          this.$toast.success('登录成功！')
          this.$emit('success', response.data)
          this.close()
        } else {
          this.$toast.error(response.message || '登录失败')
          this.refreshCaptcha()
          this.form.captcha = ''
        }
      } catch (error) {
        console.error('Login error:', error)
        const errorMsg = error.response?.data?.message || error.message || '网络连接失败'
        this.$toast.error(errorMsg)
        this.refreshCaptcha()
        this.form.captcha = ''
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.login-dialog {
  background: white;
  border-radius: 12px;
  padding: 28px 32px;
  width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.dialog-header h3 {
  font-size: 18px;
  color: #1e293b;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #94a3b8;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #f1f5f9;
  color: #64748b;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #0066ff;
  box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
}

.captcha-group {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  width: 100px;
  height: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  overflow: hidden;
  margin-bottom: 16px;
}

.captcha-image:hover {
  border-color: #0066ff;
}

.btn-login {
  background: linear-gradient(135deg, #0066ff 0%, #0052cc 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  width: 100%;
  margin-top: 4px;
  transition: all 0.3s;
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 102, 255, 0.3);
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dialog-footer {
  margin-top: 18px;
  text-align: center;
  font-size: 13px;
  color: #64748b;
}

.dialog-footer a {
  color: #0066ff;
  cursor: pointer;
  margin-left: 4px;
  font-weight: 500;
}

.dialog-footer a:hover {
  text-decoration: underline;
}
</style>
